"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_CLIENTE_CDR = void 0;
exports.ESTATUS_CLIENTE_CDR = { DISPONIBLE: 1, PENDIENTE: 2 };
